/**
 * 关键字相关actions
 * @author wangyichen
 * @since 18/08/06
 */
// import ACTIONS from 'constants/action.json5';
import { saveKeyword as saveKeywordApi } from 'api/case';
export function setKeyword(keyword) {
  return async () => {
    try {
      await saveKeywordApi(keyword);
      // dispatch({
      //   type: ACTIONS.SET_KEYWORD,
      //   keywordId,
      // });
    } catch (e) {
      console.log(e);
    }
  };
}
